<template>
  <div class="MonitorMaintenanceWindowList" v-if="windowsLoaded">
    <base-alert v-if="windows.length === 0">No maintenance windows</base-alert>
    <table class="table" v-if="windows.length > 0">
      <thead>
        <col width="40%">
        <col width="40%">
        <col width="20%">
        <tr>
          <th>Starts at</th>
          <th>Ends at</th>
          <th></th>
        </tr>
      </thead>
      <tr v-for="window in windows"
          :key="window.id">
        <td>{{ window.starts_at }}</td>
        <td>{{ window.ends_at }}</td>
        <td>
          <base-button class="delete-button"
                       :loading="window.deleting"
                       @click="deleteWindow(window)">Delete</base-button>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import monitorsApi from '@/api/monitorsApi.js'
import maintenanceWindowsApi from '@/api/maintenanceWindowsApi.js'

export default {
  props: {
    monitor: {
      required: true,
      type: Object
    }
  },

  data () {
    return {
      windows: [],
      windowsLoaded: false
    }
  },

  created () {
    this.loadWindows()
  },

  methods: {
    async loadWindows () {
      this.windows = await monitorsApi.getMaintenanceWindows(this.monitor.id)
      this.windowsLoaded = true
    },

    async deleteWindow (window) {
      this.$set(window, 'deleting', true)

      await maintenanceWindowsApi.delete(window.id)

      this.loadWindows()
    }
  }
}
</script>

<style lang="scss" scoped>
  .MonitorMaintenanceWindowList {
    .delete-button {
      width: 150px;
      float: right;
    }
  }
</style>
